import { Moment } from "moment";
import { PaginationInquiry } from "../../../../helper/pagination";
import { Action } from "../../customer/entity/customer.model";
import { Entity, MOption } from "../../shared/shared.model";
import { PromotionProductUI } from "./promotion-product.model";

export interface PromotionBase {
  uuid?: string;
  name?: string;
  imgPath?: any;
  stock?: string;
  channels?: string[];
  isExclusive: boolean;
  promotionCondition?: ConditionType;
  isProductSpecified: boolean;
  isRepetitive: boolean;
  minDiverseCount?: number;
  brandId?: string;
  minUnit?: number;
  productSpecification?: ProductSpecificationType;
  benefitType?: BenefitType;
  fixedAmount?: number;
  percentage?: number;
  conditionProducts: PromotionProductUI[];
  benefitProducts: PromotionProductUI[];
  routeId?: string;
}

export enum PromotionProductType {
  BENEFIT_PRODUCT,
  CONDITION_PRODUCT,
}

export enum ConditionType {
  AMOUNT = "AMOUNT",
  NUMBER = "NUMBER",
}

export enum ProductSpecificationType {
  ONE = "ONE",
  MULTIPLE = "MULTIPLE",
  BRAND = "BRAND",
}

export enum BenefitType {
  PRODUCT = "PRODUCT",
  PERCENTAGE = "PERCENTAGE",
  FIXED_AMOUNT = "FIXED_AMOUNT",
}

export interface Promotion extends PromotionBase {
  startDate: string;
  endDate: string;
}

export interface PromotionInquiry extends PaginationInquiry {
  date?: string;
  startDate?: string;
  endDate?: string;
  channel?: string[];
  name?: string;
  routeId?: string;
}

export interface PromotionUI extends PromotionBase, MOption {
  key?: number;
  index?: number;
  actions?: Action[];
  startDate?: Moment;
  endDate?: Moment;
  imgPath?: any;
  brand?: Entity;
}
